import React, { useState, useEffect } from 'react'
import { useTheme } from "@mui/material/styles";
import useMediaQuery from '@mui/material/useMediaQuery'
import { useRequestUrl } from "../context/contextHooks";
import { useCourt } from '../context/contextHooks';
import API from '../http/API';
import Header from './Header';
import CustomHeader from "./CustomHeader";

const HeaderSource = () => {
    const [court,] = useCourt();
    const [requestUrl,] = useRequestUrl();
    const theme = useTheme();
    const small = useMediaQuery(theme.breakpoints.down('md'));
    const [uiConfig, setUiConfig] = useState(null);
    const [graphic, setGraphic] = useState(null);
    const [imageResponse, setImageResponse] = useState(null);
    const [image, setImage] = useState(null);
    const [, setActionResponse] = useState(null);

    const retrieveImage = (selectedGraphic) => {
        if (selectedGraphic) {
            setImageResponse(null);
            const url = `${requestUrl}/getImage/${selectedGraphic.key}`;
            API.getBinary(url, null, setImageResponse, setActionResponse);
        }
    }

    const pickGraphic = (graphics, small) => {
        if (!graphics) return null;
        if (graphics.length < 2) return graphics[0];
        let grafix;
        if (small) {
            grafix = graphics.filter(g => g.screenSize === 'xs');
            if (grafix.length < 1) grafix = graphics.filter(g => !g.screenSize);
            if (grafix.length < 1) grafix = graphics.filter(g => g.screenSize !== 'xl');
        } else {
            grafix = graphics.filter(g => g.screenSize === 'xl');
            if (grafix.length < 1) grafix = graphics.filter(g => !g.screenSize);
            if (grafix.length < 1) grafix = graphics.filter(g => g.screenSize !== 'xs');
        }
        return grafix ? grafix[0] : graphics[0];
    }

    useEffect(() => {
        if (court && court.headerConfig) {
            setUiConfig(court.headerConfig);
            const newGraphic = pickGraphic(court.headerGraphics, small);
            if (newGraphic !== graphic) {
                setGraphic(newGraphic);
                retrieveImage(newGraphic);
            }
        } else {
            setUiConfig(null);
            setGraphic(null);
            setImage(null);
            setImageResponse(null);
        }
    }, [court, small])

    useEffect(() => {
        if (graphic && !imageResponse && !image) {
            retrieveImage(graphic);
        } else if (graphic && imageResponse) {
            const file = new Blob([imageResponse], {type: graphic.contentType});
            file.name = graphic.fileName;
            setImage(file);
            setImageResponse(null);
        }
    }, [graphic, imageResponse, image])

    return (
        <>
            { image && uiConfig ?
                <CustomHeader image={image} uiConfig={uiConfig}/> :
                <Header />
            }
        </>
    );
}

export default HeaderSource;
